import {
    Box,
    Typography,
} from '@mui/material'
import { Image } from 'antd'
import AboutCreditBanner from '../../../assets/about-us/about-credit-banner.jpg'
import { useTranslation } from 'react-i18next'


export const SMAppAboutCredit: React.FC = () => {
    const { t } = useTranslation()

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: '12px',
                paddingRight: '12px',
                paddingTop: '60px',
                alignItems: 'center',
                backgroundColor: '#FFFFFF',
            }}
        >
            <Box>
                <Image src={AboutCreditBanner} alt='' style={{ objectFit: 'cover', borderRadius: '10px' }} preview={false}></Image>
            </Box>

            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                paddingTop: '20px',
                paddingLeft: '12px',
                paddingRight: '12px',
            }}>
                <Typography fontSize={24} fontWeight={700} color={'#141F39'}>
                    {t('t98')}
                </Typography>

                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'20px'}>
                    {t('t99')}
                </Typography>
                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'20px'}>
                    {t('t100')}
                </Typography>

                {/* <Box sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    paddingTop: '40px',
                }}>
                    <Box>
                        <Image src={AboutEstablished} width={80} height={80} alt='' preview={false}></Image>
                        <Typography fontSize={18} fontWeight={600} color={'#141F39'} paddingTop={'10px'}>Established in 2020</Typography>
                    </Box>

                    <Box sx={{
                        paddingTop: '24px',
                    }}>
                        <Image src={AboutCertified} width={80} height={80} alt='' preview={false}></Image>
                        <Typography fontSize={18} fontWeight={600} color={'#141F39'} paddingTop={'10px'}>Certified financing product </Typography>
                    </Box>
                </Box> */}
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMAppAboutCredit
